import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import ExternalLink from "./ExternalLink";
import NavLinkItems from "./NavLinkItems";

const STATIC_QUERY = graphql`
  query NavQuery {
    home {
      externalLinks {
        id
        title
        url
      }
    }
  }
`;

export default function Nav({ hardcodedLinks, absolutePath }) {
  const data = useStaticQuery(STATIC_QUERY);
  const { externalLinks } = data.home;
  return (
    <nav className="hidden pt-20 lg:pt-0 lg:ml-auto lg:mr-20 lg:flex">
      <ul className="lg:flex" id="nav-list" data-cy="primary-nav-list">
        <NavLinkItems
          hardcodedLinks={hardcodedLinks}
          absolutePath={absolutePath}
        />
        {(externalLinks || []).map((link) => (
          <li key={link.id} className="lg:ml-8 lg:items-center lg:flex">
            <span className="hover hover-1">
              <ExternalLink
                className="block py-1 text-2xl font-semibold text-center text-jumbo lg:inline-block lg:text-sm"
                href={link.url}
                title={link.title}
              >
                {link.title}
              </ExternalLink>
            </span>
          </li>
        ))}
      </ul>
    </nav>
  );
}
